import { type ReactNode } from 'react'
import { usePlatformRole } from '@/hooks/usePlatformRole'
import { PlatformRoleContext } from '@/contexts/platform-role-context'

export function PlatformRoleProvider({ children }: { children: ReactNode }) {
  const value = usePlatformRole()
  return (
    <PlatformRoleContext.Provider value={value}>
      {children}
    </PlatformRoleContext.Provider>
  )
}
